<template>
    <v-list-item
        v-for="(url, index) in urls"
        :key="`product-retailer-item-url-${index}`"
        class="retailer-item"
        :href="url.url"
        target="_blank"
        :title.prop="`Authorized Retailer ${brandName}`"
    >
        <img
            v-if="logoSrc"
            class="retail-logo"
            :src="logoSrc"
            :alt="`Authorized Retailer ${brandName}`"
            style="height: 95%"
        />
        <div v-else>{{ brandName }}</div>
        <template #append>
            <v-icon
                :icon="mdiOpenInNew"
                size="18"
            ></v-icon>
        </template>
    </v-list-item>
</template>

<script lang="ts" setup>
    import type { ProcessedProductRetailer } from '~/types';
    import { mdiOpenInNew } from '@mdi/js';

    const props = defineProps<{
        item: ProcessedProductRetailer;
    }>();

    const org = ref(props.item[0]);
    const urls = ref(props.item[1]);

    const brandName = computed<string>(() => org.value.name ?? '');
    const logoSrc = computed<Nilish<string>>(() => org.value.brand?.primaryLogo?.url);
</script>

<style lang="scss"></style>
